import React from 'react';

export default function ExitToDashboardSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="66" height="74" viewBox="0 0 66 74">
      <g fill="none">
        <path
          fill="#2B5672"
          d="M66 67H38V14.294C38 12.474 39.223 11 40.732 11h22.536C64.777 11 66 12.475 66 14.294V67"
        />
        <path
          fill="#FDB5B4"
          d="M66 68.067L45 74V18.351c0-1.613.939-3.003 2.245-3.322l16.239-3.978c1.3-.318 2.516.886 2.516 2.493v54.523"
        />
        <path
          fill="#F1726B"
          d="M37.966 8.33C30.928-.917 17.682-2.742 8.38 4.255-.923 11.25-2.759 24.42 4.28 33.669c7.038 9.25 20.284 11.074 29.587 4.077a21.008 21.008 0 0 0 5.047-5.42L43 31.88l-2.26-3.093c2.644-6.602 1.853-14.377-2.774-20.456"
        />
        <path
          fill="#FFF"
          d="M21 17.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M35 17.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
        />
        <path stroke="#FFF" d="M33 25a7 7 0 1 1-14 0" />
        <path
          fill="#FACDCA"
          d="M35 66.5c0 .828-6.044 1.5-13.5 1.5S8 67.328 8 66.5c0-.829 6.044-1.5 13.5-1.5s13.5.671 13.5 1.5"
        />
      </g>
    </svg>
  );
}

ExitToDashboardSvg.displayName = 'ExitToDashboardSvg';
